// extracted by mini-css-extract-plugin
export default {"treasurer":"Treasurer_treasurer__D1XyN","reload":"Treasurer_reload__Fa3hX","accept":"Treasurer_accept__lvhdv","treasurerModel":"Treasurer_treasurerModel__DgOqX"};